import { mdiCalendar, mdiClock, mdiInformation, mdiPlus, mdiPencil, mdiDelete, mdiDotsVertical, mdiContentDuplicate, mdiContentCopy, mdiContentPaste } from '@mdi/js'

export const defaultOptions = {
  locale: '',
  defaultLocale: '',
  rootDisplay: '',
  objectContainerClass: '',
  sectionsClass: 'pl-2 pt-2',
  sectionsTitlesClasses: ['title', 'subtitle-1', 'subtitle-2'],
  arrayItemsTitlesClasses: ['title', 'subtitle-1', 'subtitle-2'],
  childrenClass: '',
  fieldProps: {},
  fieldColProps: { cols: 12 },
  readOnlyFieldProps: { hideDetails: true },
  textFieldProps: {},
  textareaProps: { filled: true },
  numberProps: {},
  sliderProps: {},
  checkboxProps: {},
  switchProps: {},
  comboboxProps: {},
  selectProps: {},
  fileInputProps: {},
  radioGroupProps: {},
  radioItemProps: {},
  tabsProps: { grow: true },
  expansionPanelsProps: { mandatory: true },
  dialogProps: { maxWidth: 500 },
  dialogCardProps: {},
  colorPickerProps: {},
  timePickerProps: {},
  datePickerProps: { scrollable: true },
  arrayItemCardProps: {},
  arrayItemColProps: { cols: 12 },
  stepperProps: {},
  verticalStepperProps: {},
  tooltipProps: { left: true, openOnHover: false, openOnClick: true },
  removeAdditionalProperties: true,
  disableAll: false,
  hideReadOnly: false,
  hideReadOnlyLabels: false,
  hideReadOnlyEmpty: false,
  hideReadOnlyTooltips: false,
  deleteReadOnly: false,
  hideInArrayItem: false,
  filesAsDataUrl: false,
  hideTooltips: false,
  disableSorting: false,
  sortableOptions: {},
  context: {},
  rules: {},
  initialValidation: 'defined',
  idPrefix: '',
  markdownit: {},
  editMode: 'dialog',
  arrayOperations: ['create', 'update', 'duplicate', 'copy', 'paste', 'delete'],
  autofocus: false,
  httpOptions: {},
  selectAll: false,
  autoFixArrayItems: true,
  useValidator: false,
  evalMethod: 'propertyExpr',
  easyMDEOptions: {},
  maxLengthCounter: true
}

export const localizedMessages = {
  en: {
    required: 'This information is required',
    noData: 'No matching value found',
    search: 'Search...',
    minimum: 'The value must be greater than or equal to {minimum}',
    exclusiveMinimum: 'The value must be greater than {exclusiveMinimum}',
    maximum: 'The value must be lower than or equal to {maximum}',
    exclusiveMaximum: 'The value must be lower than {exclusiveMaximum}',
    minLength: '{minLength} characters minimum',
    maxLength: '{maxLength} characters maximum',
    minItems: 'No less than {minItems} items',
    maxItems: 'No more than {maxItems} items',
    pattern: 'The expected pattern is not satisfied',
    mdeLink1: '[Link title',
    mdeLink2: '](link url)',
    mdeImg1: '![](',
    mdeImg2: 'image url)',
    mdeTable1: '',
    mdeTable2: '\n\n| Column 1 | Column 2 | ColoColumnnne 3 |\n| -------- | -------- | -------- |\n| Text     | Text     | Text     |\n\n',
    bold: 'Bold',
    italic: 'Italic',
    heading: 'Title',
    quote: 'Quote',
    unorderedList: 'Unordered list',
    orderedList: 'Ordered list',
    createLink: 'Create a link',
    insertImage: 'Insert an image',
    createTable: 'Create a table',
    preview: 'Aperçu du rendu',
    mdeGuide: 'Documentation de la syntaxe',
    undo: 'Undo',
    redo: 'Redo',
    selectAll: 'Select all',
    stepperContinue: 'continue',
    openMenu: 'open menu',
    delete: 'delete',
    duplicate: 'duplicate',
    copy: 'copy',
    paste: 'paste'
  },
  fr: {
    required: 'Cette information est obligatoire',
    noData: 'Aucun élément correspondant',
    search: 'Recherchez...',
    minimum: 'La valeur doit être supérieure ou égale à {minimum}',
    exclusiveMinimum: 'La valeur doit être supérieure {exclusiveMinimum}',
    maximum: 'La valeur doit être inférieure ou égale à {maximum}',
    exclusiveMaximum: 'La valeur doit être inférieure à {exclusiveMaximum}',
    minLength: '{minLength} caractères minimum',
    maxLength: '{maxLength} caractères maximum',
    minItems: 'Au moins {minItems} éléments',
    maxItems: 'Au plus {maxItems} éléments',
    pattern: `Le format attendu n'est pas respecté`,
    mdeLink1: '[titre du lien',
    mdeLink2: '](adresse du lien)',
    mdeImg1: '![](',
    mdeImg2: 'adresse de l\'image)',
    mdeTable1: '',
    mdeTable2: '\n\n| Colonne 1 | Colonne 2 | Colonne 3 |\n| -------- | -------- | -------- |\n| Texte     | Texte     | Texte     |\n\n',
    bold: 'Gras',
    italic: 'Italique',
    heading: 'Titre',
    quote: 'Citation',
    unorderedList: 'Liste à puce',
    orderedList: 'Liste numérotée',
    createLink: 'Créer un lien',
    insertImage: 'Insérer une image',
    createTable: 'Créer un tableau',
    preview: 'Preview',
    mdeGuide: 'Syntax documentation',
    undo: 'Défaire',
    redo: 'Refaire',
    selectAll: 'Tout sélectionner',
    stepperContinue: 'continuer',
    openMenu: 'ouvrir le menu',
    delete: 'supprimer',
    duplicate: 'dupliquer',
    copy: 'copier',
    paste: 'coller'
  },
  es: {
    required: 'Esta información es requerida',
    noData: 'No se encontraron valores coincidentes',
    search: 'Buscar...',
    minimum: 'El valor debe ser mayor o igual que {minimum}',
    exclusiveMinimum: 'El valor debe ser mayor que {exclusiveMinimum}',
    maximum: 'El valor debe ser menor o igual a {maximum}',
    exclusiveMaximum: 'El valor debe ser inferior a {exclusiveMaximum}',
    minLength: '{minLength} caracteres mínimo',
    maxLength: '{maxLength} caractères máximo',
    minItems: 'Al menos {minItems} articulos',
    maxItems: 'Hasta {maxItems} articulos',
    pattern: 'El formato esperado no se respeta',
    selectAll: 'Seleccionar todo',
    stepperContinue: 'continuar'
  },
  de: {
    required: 'Diese Informationen sind erforderlich',
    noData: 'Keine passenden Artikel',
    search: 'Suche...',
    minimum: 'Der Wert muss größer oder gleich {minimum} sein',
    exclusiveMinimum: 'Der Wert muss größer als {exclusiveMinimum} sein',
    maximum: 'Der Wert muss kleiner oder gleich {maximum} sein',
    exclusiveMaximum: 'Der Wert muss kleiner als {exclusiveMaximum} sein',
    minLength: 'Mindestens {minLength} Zeichen',
    maxLength: 'Maximal {maxLength} Zeichen',
    minItems: 'Mindestens {minItems} Elemente',
    maxItems: 'Bis zu {maxItems} Artikel',
    pattern: 'Das erwartete Format wird nicht eingehalten',
    selectAll: 'Wählen Sie Alle',
    stepperContinue: 'weiter'
  },
  ar: {
    required: 'هذه المعلومة مطلوبة',
    noData: 'لم يتم العثور على قيمة',
    search: 'جاري البحث...',
    minimum: '{exclusiveMinimum} القيمة يجب أن تكون أكبر من', // TODO, same as exclusiveMinimum waiting for a proper translation
    exclusiveMinimum: '{exclusiveMinimum} القيمة يجب أن تكون أكبر من',
    maximum: '{maximum} القيمة يجب أن تكون أقل من', // TODO, same as exclusiveMaximum waiting for a proper translation
    exclusiveMaximum: '{exclusiveMaximum} القيمة يجب أن تكون أقل من',
    minLength: '{minLength} الحد الأدنى للحروف المطلوبة هو',
    maxLength: '{maxLength} الحد الأقصى للحروف المطلوبة هو',
    minItems: 'قطع {minItems} لا يمكن اختيار أقل من ',
    maxItems: 'قطع {maxItems} لا يمكن اختيار أكثر من ',
    pattern: 'لا يوجد تشابه مع النموذج المطلوب',
    selectAll: 'اختر الكل',
    stepperContinue: 'استمر'
  },
  tr: {
    required: 'Zorunlu alan',
    noData: 'Bilgi yok',
    search: 'Arıyor...',
    minimum: 'Değer {minimum} dan büyük olmalı',
    exclusiveMinimum: 'Değer {exclusiveMinimum} dan büyük olmalı',
    maximum: 'Değer, {maximum} değerinden küçük veya ona eşit olmalıdır',
    exclusiveMaximum: 'Değer {exclusiveMaximum} dan küçük olmalı',
    minLength: '{minLength} asgari karakter sayısı',
    maxLength: '{maxLength} azami  karakter sayısı',
    minItems: 'En az seçenek sayısı {minItems}',
    maxItems: 'En çok seçenek sayısı {maxItems}',
    pattern: 'İstenilen paten tutmuyor',
    selectAll: 'Hepsini seç',
    stepperContinue: 'devam et'
  },
  nl: {
    required: 'Deze informatie is vereist',
    noData: 'Geen overeenkomstig resultaat gevonden',
    search: 'Zoeken...',
    minimum: 'De waarde moet groter zijn dan of gelijk zijn aan {minimum}',
    exclusiveMinimum: 'Waarde moet meer zijn dan {exclusiveMinimum}',
    maximum: 'De waarde moet lager zijn dan of gelijk zijn aan {maximum}',
    exclusiveMaximum: 'Waarde moet minder zijn dan {exclusiveMaximum}',
    minLength: 'Minimaal {minLength} tekens',
    maxLength: 'Maximaal {maxLength} tekens',
    minItems: 'Minimaal {minItems} antwoorden',
    maxItems: 'Maximaal {maxItems} antwoorden',
    pattern: 'Invoer voldoet niet aan verwachte patroon',
    selectAll: 'Selecteer alles',
    stepperContinue: 'doorgaan'
  },
  ja: {
    required: 'この情報は必須です。',
    noData: '一致する値はありません。',
    search: '検索...',
    minimum: '値は{minimum}以上である必要があります。',
    exclusiveMinimum: '値は{exclusiveMinimum}より大きい必要があります。',
    maximum: '値は{maximum}以下である必要があります。',
    exclusiveMaximum: '値は{exclusiveMaximum}より小さい必要があります。',
    minLength: '最小文字数は{minLength}です。',
    maxLength: '最大文字数は{maxLength}です。',
    minItems: '最小項目数は{minItems}です。',
    maxItems: '最大項目数は{maxItems}です。',
    pattern: '期待される様式を満たしていません。',
    mdeTable2: '\n\n| Column 1 | Column 2 | ColoColumnnne 3 |\n| -------- | -------- | -------- |\n| Text     | Text     | Text     |\n\n',
    bold: '太字',
    italic: 'イタリック',
    heading: 'タイトル',
    quote: '引用',
    unorderedList: '順序なしリスト',
    orderedList: '順序付きリスト',
    createLink: 'リンクを生成',
    insertImage: '画像を挿入',
    createTable: 'テーブル作成',
    preview: 'プレビュー',
    mdeGuide: '構文に関するドキュメント',
    undo: '元に戻す',
    redo: 'やり直し',
    selectAll: '全選択',
    stepperContinue: 'コンティニュー',
    openMenu: 'メニューを開く',
    delete: '削除',
    duplicate: '重複',
    copy: 'コーピー',
    paste: 'ペースト'
  }
}

export const formats = {
  time: (time, locale) => {
    const date = new Date(`${new Date().toISOString().split('T')[0]}T${time}`)
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000)).toLocaleTimeString(locale)
  },
  date: (dateStr, locale) => {
    const date = new Date(dateStr)
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000)).toLocaleDateString(locale)
  },
  'date-time': (dateTime, locale) => {
    return new Date(dateTime).toLocaleString(locale)
  }
}

export const iconSets = {
  mdiSvg: {
    calendar: mdiCalendar,
    clock: mdiClock,
    info: mdiInformation,
    add: mdiPlus,
    edit: mdiPencil,
    delete: mdiDelete,
    arrayMenu: mdiDotsVertical,
    duplicate: mdiContentDuplicate,
    copy: mdiContentCopy,
    paste: mdiContentPaste
  },
  mdi: {
    calendar: 'mdi-calendar',
    clock: 'mdi-clock',
    info: 'mdi-information',
    add: 'mdi-plus',
    edit: 'mdi-pencil',
    delete: 'mdi-delete',
    arrayMenu: 'mdi-dots-vertical',
    duplicate: 'mdi-plus-circle-multiple-outline',
    copy: 'mdi-content-copy',
    paste: 'mdi-content-paste'
  },
  md: {
    calendar: 'event',
    clock: 'clock',
    info: 'info',
    add: 'add',
    edit: 'create',
    delete: 'delete',
    arrayMenu: 'more_vert',
    duplicate: 'control_point_duplicate',
    copy: 'copy',
    paste: 'paste'
  },
  fa: {
    calendar: 'fa-calendar',
    clock: 'fa-clock',
    info: 'fa-info',
    add: 'fa-plus',
    edit: 'fa-edit',
    delete: 'fa-trash',
    arrayMenu: 'fa-ellipsis-vertical',
    duplicate: 'fa-layer-plus',
    copy: 'fa-copy',
    paste: 'fa-paste'
  }
}
